import React from 'react';

import WelcomeContent from '../WelcomeContent';

interface WelcomeProps {
  isProSubscriber: boolean;
  handleNext: () => void;
  handleClose: () => void;
}

const Welcome = ({ isProSubscriber, handleNext, handleClose }: WelcomeProps) => (
  <div id="welcome-tooltip" className="h-[264px] w-[416px] bg-grayscale-charcoal px-32 py-24">
    <WelcomeContent
      variant="desktop"
      isProSubscriber={isProSubscriber}
      handleNext={handleNext}
      handleClose={handleClose}
    />
  </div>
);

export default Welcome;
